var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['card', _vm.dark ? 'bg-glass-dark' : 'bg-glass', !_vm.noShadow ? '' : 'shadow-sm', _vm.customClass]},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_c('div',{class:['card-body text-light', _vm.bodyClass]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }